import {GetServerSideProps} from "next";
import {Filter} from "../data/Filter/Filter.config";
import {Languages} from "../data/Languages.config";
import {getSequelizeItemsByQueryParams} from "../data/ObjectsDataHelper";
import {getSafeLocale} from "../helpers/LocalizeObject";
import {objects} from "../models/objects";
import {readdirSync} from 'node:fs';
import {REGION_CONTENT_PAGES} from "./costa-brava/[region]";
import {LEISTUNGEN_CONTENT_PAGES} from "./leistungen/[leistung]";

//pages/sitemap.xml.js
export const EXTERNAL_DATA_URL = "https://leon-inmobiliaria.com";

function generateSiteMap(rentalObjects: objects[], salesObjects: any[]) {

	let pages: string[] = [];


	// Region pages
	for (let region of REGION_CONTENT_PAGES) {
		pages.push(`${EXTERNAL_DATA_URL}/{lang}/costa-brava/${region.params.region}`)
	}
	// Leistungen
	for (let service of LEISTUNGEN_CONTENT_PAGES) {
		pages.push(`${EXTERNAL_DATA_URL}/{lang}/leistungen/${service.params.leistung}`)
	}

	const pageDir = "/srv/app/pages"

	const rootFiles = readdirSync(pageDir, {withFileTypes: true})
		.filter((file) => !file.isDirectory())
		.map((file) => file.name)
		.filter(
			(file) =>
				!file.startsWith("(") && !file.startsWith("_") && file !== "500.tsx" && file !== "404.tsx" && file !== "contact-success.tsx" && file !== "sitemap.xml.ts"
		);
	for (let file of rootFiles) {
		pages = [...pages, `${EXTERNAL_DATA_URL}/{lang}/${file.replace(".tsx", "").replace("index", "")}`]
	}

	const contentDirectories = readdirSync(pageDir, {withFileTypes: true})
		.filter((file) => file.isDirectory())
		.map((folder) => folder.name)
		.filter(
			(folder) =>
				!folder.startsWith("(") && !folder.startsWith("_") && folder !== "api"
		);
	for (let dir of contentDirectories) {
		const files = readdirSync(`${pageDir}/${dir}`);
		pages = [...pages, ...files.filter(f => !f.startsWith("[") && !f.startsWith("_")).map(f =>
			`${EXTERNAL_DATA_URL}/{lang}/${dir}/${f.replace(".tsx", "").replace("index", "")}`
		)]
	}


	pages = pages.filter(p => !p.includes("verkaufsanfrage") && !p.includes("buchungsanfrage") && !p.startsWith("_") && p !== "500" && p !== "400")
	console.log(pages);


	let html = "";
	for (let page of pages) {
		html += `
        <url>
            <loc>${page.replace("{lang}/", "")}</loc>
            <changefreq>weekly</changefreq>
            ${Languages.map(
			(l) => `<xhtml:link
            rel="alternate"
            hreflang="${l.hreflang}"
            href="${page.replace("{lang}/", `${l.url}/`)}" />`
		).join(`
            `)}
        </url>`;
	}

	for (let object of rentalObjects) {
		html += `
        <url>
            <loc>${`${EXTERNAL_DATA_URL}/vermietung/${object.id}`}</loc>
            <changefreq>weekly</changefreq>
            <lastmod>${new Date(
			parseInt(object.date_change) * 1000
		).toISOString()}</lastmod>
            ${Languages.map(
			(l) => `<xhtml:link
            rel="alternate"
            hreflang="${l.hreflang}"
            href="${`${EXTERNAL_DATA_URL}/vermietung/${l.url}/${object.id}`}" />`
		).join(`
            `)}
        </url>`;
	}
	for (let object of salesObjects) {
		html += `
        <url>
            <loc>${`${EXTERNAL_DATA_URL}/verkauf/${object.id}`}</loc>
            <changefreq>weekly</changefreq>
            <lastmod>${new Date(
			parseInt(object.date_change) * 1000
		).toISOString()}</lastmod>
            ${Languages.map(
			(l) => `<xhtml:link
            rel="alternate"
            hreflang="${l.hreflang}"
            href="${`${EXTERNAL_DATA_URL}/verkauf/${l.url}/${object.id}`}" />`
		).join(`
`)}
        </url>`;
	}

	return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml">
  
     ${html}
   </urlset>
 `;
}

function SiteMap() {
	// getServerSideProps will do the heavy lifting
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const rentalQuery = { /* "page": "1", */ [Filter.Rent.queryKey]: "1"};
	const rentalObjects = await getSequelizeItemsByQueryParams(
		rentalQuery,
		"objects",
		getSafeLocale(context.locale),
		999999
	);

	const salesQuery = { /* "page": "1", */ [Filter.Sale.queryKey]: "1"};
	const salesObjects = await getSequelizeItemsByQueryParams(
		salesQuery,
		"objects",
		getSafeLocale(context.locale),
		999999
	);
	// We generate the XML sitemap with the posts data
	const sitemap = generateSiteMap(rentalObjects.items, salesObjects.items);

	context.res.setHeader("Content-Type", "text/xml");
	// we send the XML to the browser
	context.res.write(sitemap);
	context.res.end();

	return {
		props: {}
	};
};

export default SiteMap;
